import React from 'react';
import styled from 'styled-components';

// styles
const Wrapper = styled.div`
    width: 100%;
`;

const Header = styled.div`
    width: 100%;
    margin-bottom: 8px;
    text-align: center;
`;

const HeaderContainer = styled.div`
    width: 100%;
    position: relative;
    display: flex;   
    flex-wrap: nowrap; 
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 0px;
    border-bottom: .5px solid #CCCCCC;
    ${p => p.borderBottom && `
        border-bottom: ${p.borderBottom};
    `}
    @media (max-width: 450px) {
        ${p => p.mobileSpaceBetweenItems && `
            justify-content: space-between;
            gap: 0px;
        `}
    }
`;

const Items = styled.div`
    cursor: pointer;
    padding: 10px 16px;
    padding-bottom: 16px;
    transition: all .3s ease;
    width: auto;
    position: relative;
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    color: #61788E;
    border-bottom: 2px solid white;
    @media (max-width: 600px) {
        line-height: 30px;
        font-size: 16px;
        padding: 8px;
        ${p => p.itemsCount && p.mobileSpaceBetweenItems && `
            width: ${100/p.itemsCount}%;
        `}
    }
    ${p => p.itemsCount && p.spaceBetweenItems && `
    width: ${100/p.itemsCount}%;
    `}
    ${p => p.selected && `
        border-bottom: 2px solid #29BCAB;
        color: #29BCAB;
    `}
`;

/* TabBar Component ================================== */
const TabBar = ({
	list, select, handleChange, children, spaceBetweenItems, mobileSpaceBetweenItems, borderBottom, itemsCount
}) => (
	<Wrapper>
		<Header>
			<HeaderContainer 
                spaceBetweenItems={spaceBetweenItems}
                mobileSpaceBetweenItems={mobileSpaceBetweenItems}
            >
				{
					list.map((r, i) => (
						<Items
							key={i}
							onClick={() => handleChange(r.id)}
							selected={r.id === select}
                            spaceBetweenItems={spaceBetweenItems}
                            mobileSpaceBetweenItems={mobileSpaceBetweenItems}
                            borderBottom={borderBottom}
                            itemsCount={itemsCount}
						>
                            {r.img &&
                            <img
                                src={r.id === select ? r.activeImg : r.img}
                                alt={r.name}
                                width={r.width}
                                height={r.height}
                            />
                            }
							{r.name}
						</Items>
					))
				}
			</HeaderContainer>
		</Header>
		{children}
	</Wrapper>
);

export default TabBar;
